import Cookies from 'universal-cookie';

export const BOOKING_TYPE_HEADER = 'booking-type-id';

export const getHotelBookingTypeId = () => {
  const cookies = new Cookies();
  const hotelBookingTypeId = cookies.get('HotelBookingTypeID');
  if (hotelBookingTypeId) {
    return hotelBookingTypeId;
  }
  cookies.set('HotelBookingTypeID', '2', 1);
};

export const getPayAtHotelCheckout = items => {
  return (
    items?.find(item => item.__typename === 'HotelOrderItem')?.paymentDueAt ===
    'HOTEL_CHECKOUT'
  );
};

export const checkIsPayAtHotel = hotel => {
  return hotel?.paymentDueAt === 'HOTEL_CHECKOUT';
};

/**
 * Checks if a destination code is present in a comma-separated list of allowed destinations.
 * @param destinationCode - The airport code to check.
 * @param allowedDestinations - Comma-separated string of allowed destination codes.
 * @returns true if destinationCode is allowed, false otherwise.
 */
export const checkAvailability = (destination, allowedDestinations) => {
  if (!destination || !allowedDestinations) {
    return false;
  }

  const allowedDestinationsArray = allowedDestinations
    .split(',')
    .map(destination => destination.trim().toUpperCase())
    .filter(Boolean);
  const isAvailable = allowedDestinationsArray.includes(
    destination.toUpperCase()
  );

  return isAvailable;
};
